import styled from "styled-components";
import { FONTS } from "./styles/fonts";
import { COLORS } from "./styles/colors";

export const App = styled.div`
    font-family: ${FONTS.primary};
`